// Small presentational primitives shared across landing sections.
// Kept here so section files don't duplicate the technical-drawing style helpers.

export const SectionLabel = ({ n, name }) => (
  <div className="flex items-center gap-4 mb-10 lg:mb-14">
    <span className="grid-ref">§ {n}</span>
    <span className="h-px flex-1 bg-[color:var(--border)]" />
    <span className="grid-ref">{name}</span>
  </div>
);

export const CornerBrackets = ({ children, className = "" }) => (
  <div className={`relative ${className}`}>
    <span className="absolute -top-2 -left-2 w-4 h-4 border-t border-l border-[color:var(--ink)]" />
    <span className="absolute -top-2 -right-2 w-4 h-4 border-t border-r border-[color:var(--ink)]" />
    <span className="absolute -bottom-2 -left-2 w-4 h-4 border-b border-l border-[color:var(--ink)]" />
    <span className="absolute -bottom-2 -right-2 w-4 h-4 border-b border-r border-[color:var(--ink)]" />
    {children}
  </div>
);
